import api from "../utils/api";

/** Fetch the user's server-saved settings blob. Returns an object. */
export async function fetchUserPreferences() {
  const res = await api.get("/api/users/preferences/", { auth: true });
  return res?.data || {};
}

/** Shallow-merge and persist the given keys server-side. Returns merged blob. */
export async function updateUserPreferences(partial) {
  const res = await api.patch(
    "/api/users/preferences/",
    { data: partial },
    { auth: true }
  );
  return res?.data || {};
}
